<template>
  <div class="hearing-task">
    <div class="top-bar">
      <div class="back-icon" @click="pageBack"></div>
    </div>
    <div class="content">
      <div class="tab-bar">
        <div
          class="tab"
          v-for="item in tabList"
          :key="item.id"
          :tab="item.name"
          :data-rlog="item.rlogKey"
          @click="changeTab(item.id)"
          :class="[activeKey === item.id ? 'tab-active' : '']"
        >
          {{ item.name }}
          <div
            class="showPendingNum"
            :class="[item.pendingStatus ? 'pendingNumBox' : '']"
            v-if="activeKey==='1' &amp;&amp; Number(item.pendingStatus) !== 0"
          >
            {{ item.pendingStatus }}
          </div>
        </div>
      </div>
      <SortTask v-if="activeKey === '1'" @filterTask="filterTaskClick"></SortTask>
      <component
        :is="tabList[activeKey].components"
        :queryTaskType="queryTaskType"
        @update="changeTab('1')"
        @pendingNumChanged="changePendingNum"
      ></component>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import routeController from '@/controller/router';
import EventBus from '@/controller/EventBus';
import CreateTask from './components/CreateTask.vue';
import TaskList from './components/TaskList.vue';
import SortTask from './components/SortTask.vue';

export default {
  components: {
    TaskList,
    CreateTask,
    SortTask,
  },
  setup() {
    const queryTaskType = ref('all');
    const { getUrlParams } = routeController();
    const activeKey = ref(getUrlParams('activeKey') || '0');
    const tabList = ref([
      {
        id: '0',
        name: '创建任务',
        components: CreateTask,
        rlogKey: 'set_click',
      },
      {
        id: '1',
        name: '任务列表',
        rlogKey: 'list_click',
        pendingStatus: '',
        components: TaskList,
      },
    ]);
    function changeTab(value) {
      activeKey.value = value;
    }
    EventBus.back.addEventLister('back', changeTab);
    function filterTaskClick(val) {
      queryTaskType.value = val;
    }
    function changePendingNum(val) {
      tabList.value[1].pendingStatus = val;
    }
    return {
      queryTaskType,
      tabList,
      activeKey,
      changeTab,
      filterTaskClick,
      changePendingNum,
      ...routeController(),
    };
  },
};
</script>
<style lang="scss" scoped>
.tab-bar {
  display: flex;
  width: 240px;
  height: 48px;
  text-align: center;
  font-size: 14px;
  background: #f5f6f8;
  border-radius: 12px;
  line-height: 48px;
  color: #898a8e;
  margin: 0 auto;
  padding: 0 2px;
  .tab {
    width: 120px;
    cursor: pointer;
    font-weight: 500;
  }
  .tab-active {
    width: 120px;
    background: #ffffff;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.08);
    border-radius: 10px;
    color: #212327;
    height: 44px;
    line-height: 44px;
    margin: 2px 0;
  }
  .pendingNumBox {
    display: inline-block;
    position: relative;
    width: 19px;
    height: 19px;
    left: 4px;
    top: -1px;
    border-radius: 50%;
    font-size: 10px;
    line-height: 19px;
    font-weight: bold;
    color: #fff;
    background: #ff333a;
    box-shadow: 0px 1px 3px rgba(255, 51, 58, 0.2);
  }
}
.content {
  box-shadow: 0px 12px 30px rgba(0, 0, 0, 0.02);
  background: #fff;
  border-radius: 8px;
  position: absolute;
  top: 80px;
  left: 40px;
  right: 40px;
  bottom: 40px;
  padding: 22px 0 0 0;
  overflow: auto;
  scrollbar-gutter: stable;
}
.hearing-task {
  background: #f5f6f8;
  padding: 0 100px 40px 40px;
  box-sizing: border-box;
  height: 100%;
  position: relative;
}
.top-bar {
  height: 80px;
  padding-top: 43px;
}
.back-icon {
  width: 58px;
  height: 24px;
  cursor: pointer;
  background: url('./imgs/back.png') center center no-repeat;
  background-size: 100% 100%;
}
</style>
